import React from "react";
import classNames from "classnames";
import "./index.scss";
import IconButton from "../IconButton";
import {useTranslation} from "react-i18next";
import {getTranslateTitle} from "../../../utils/objects-util.js";

const AddButton = ({ text, disabled, onClick }) => {
    const { t } = useTranslation();
    const handleClick = (e) => {
        !disabled && onClick()
    }
    return (
        <div className={classNames("addButton", { disabled: !!disabled })} onClick={handleClick}>
            <span className={classNames("addButtonText")}>{getTranslateTitle(text) || t('settings.ADD_BUTTON')}</span>
            <IconButton isIcon iconName={"addNew"}/>
        </div>
    )
};

export default AddButton;
